import React, { RefObject, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import QRCodeComponent from '../QRCodeComponent/QRCodeComponent';
import Timer from '../Timer/Timer';
import type { TimerHandle } from '../Timer/Timer';
import { isMobileDevice } from '~/helpers/deviceDetection';
import { onDeepLinkClick } from './utils';
import { styles } from './styles';

export type TimerRefHandle = TimerHandle;

interface DiiaQRCodeProps {
  deepLink?: string;
  timerRef: RefObject<TimerRefHandle | null>;
  qrCodeTimer: number;
  diiaTitle: string;
  onTimeUp?: () => void;
  instructionText: string;
  inRow?: boolean;
}

export const DiiaQRCode = ({
  deepLink,
  timerRef,
  qrCodeTimer,
  diiaTitle,
  onTimeUp,
  instructionText,
  inRow,
}: DiiaQRCodeProps) => {
  const isPortableDevice = isMobileDevice();
  const [showMobileQr, setShowMobileQr] = useState<boolean>(false);

  const handleTimeUp = (): void => {
    onTimeUp?.();
  };

  const handleOnUrl = (): void => {
    if (deepLink != null) {
      onDeepLinkClick(deepLink);
    }
  };

  return (
    <>
      <Typography variant="h5" component="h5" sx={styles.title}>
        {diiaTitle}
      </Typography>
      <Box sx={styles.container}>
        {isPortableDevice && (
          <Box>
            <Timer ref={timerRef} onTimeUp={handleTimeUp} initialTime={qrCodeTimer} />
          </Box>
        )}

        {isPortableDevice && (
          <Box sx={styles.mobileActions}>
            <Button
              variant="contained"
              onClick={handleOnUrl}
              data-testid="verif-btn-primary"
              sx={styles.primaryButton}
            >
              Відкрити застосунок Дія
            </Button>

            <Button
              variant="text"
              onClick={() => setShowMobileQr((prev) => !prev)}
              onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
              data-testid="verif-btn-next"
              sx={styles.toggleButton}
            >
              {showMobileQr ? 'Сховати QR-код' : 'Відобразити QR-код'}
            </Button>
          </Box>
        )}

        {(!isPortableDevice || showMobileQr) && (
          <Box sx={styles.contentWrapper(inRow)}>
            <Box>
              <Box sx={styles.qrWrapper}>
                <QRCodeComponent url={deepLink} />
              </Box>

              {!isPortableDevice && (
                <Box>
                  <Timer ref={timerRef} onTimeUp={handleTimeUp} initialTime={qrCodeTimer} />
                </Box>
              )}
            </Box>

            <Box component="ol" sx={styles.instructionsList}>
              <Box component="li" sx={styles.instructionItem}>
                Відкрийте QR-сканер у застосунку Дія на мобільному пристрої
              </Box>
              <Box component="li" sx={styles.instructionItem}>
                Відскануйте QR-код.
              </Box>
              <Box component="li" sx={styles.instructionItem}>
                {instructionText}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};
